// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"3705abcd","239":"6e649cf4","455":"19149fbb","821":"ab5e732e"}[chunkId] + ".chunk.js";
};